import { Box } from "@seneca/senekit";

import { SectionRowLoading } from "features/classroom/features/sidebar/features/common";

export default function CourseContentLoading() {
  return (
    <Box marginX="xlarge">
      <SectionRowLoading />
      <SectionRowLoading />
      <SectionRowLoading />
    </Box>
  );
}
